    module.exports = {
        CONFIG: {
            sentryWebsiteDns: 'https://f3ff9fc1c9cc3239cd33142929b412b3@o4510114478030848.ingest.de.sentry.io/4510147663495248',
            sentryAuthToken: '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',
        }
    };